<template>
  <form name="publish" id="publish">
    <div class="form-group">
      <label>
        <span class="title">你的评论内容是？</span>
      </label>
      <label class="textarea-label">
        <textarea class="cc" v-model="comment" placeholder="请输入评论内容，内容将由系统审核筛选后显示，对所有人可见" ref="count"></textarea>
        <span class="words-count">{{wordsCount}}/300</span>
      </label>
    </div>
    <button class="submit-btn" type="submit" @click.prevent.stop="submit">提交评论</button>
    <modal v-show="tip" ref="tip" :download="download" :content="tip"></modal>
  </form>
</template>
<script>
  import Modal from 'components/tips/Modal.vue';
  import { postComment } from 'assets/js/community.js';
  export default {
    name: 'Publish',
    data(){
      return {
        comment: '',
        tip: '',
        wordsCount: 0,
        download: true
      }
    },
    components:{
      Modal
    },
    created(){
      let params = this.$route.params;
      let query = this.$route.query;
      console.log('comment p:', params, query);
      this.id = params.id;
      this.typeId = query.typeId;
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      }
    },
    methods: {
      async submit(){

        let tokens = this.tokens || await this.$store.dispatch('cbgcAuth',{
          cacheName: 'cbgcAuth',
          refresh: 1
        });
        // console.log('tokens:', tokens);
        if(tokens.status){
          console.log(tokens.message);
          this.tip = tokens.message;
          this.$refs.tip.taggle(true);
          return;
        }
        tokens = typeof tokens == 'string' ? tokens : tokens.access_token;

        let comment = this.comment;
        if(comment.length < 2){
          this.download = false;
          this.tip = "请输入2个字符以上再提交";
          this.$refs.tip.taggle(true);
          return;
        }

        postComment({
          id: this.id,
          data: {
            comment: this.comment
          },
          token: tokens
        }).then(res=>{
          console.log('comment res:' ,res);
          if(res.status == 201){
            // 提交成功
            this.$router.push({
              name: 'Detail',
              params: {
                id: this.id
              },
              query:{
                typeId: this.typeId
              }
            });
            // router.push({ name: 'user', params: { userId: '123' }})
          }else{
            this.download = false;
            this.tip = "提交失败，请稍后重试。";
            this.$refs.tip.taggle(true);
          }
        });
        
      }
    },
    watch:{
      comment:{
        handler(){
          let sum = 300;
          this.$refs.count.setAttribute('maxlength', sum);
          this.wordsCount = this.$refs.count.value.length;
        }
      }
    }
  }
</script>
<style lang="scss">
  .form-group{
    display: block;
    padding: .5em 1em;
    background-color: #fff;
    box-shadow: 0 0 2px rgba(150, 150, 150, 0.2);
    &:nth-child(1){
      padding: 0;
      border-top: 0 none;
    }
    label{
      display: block;
    }
    .intro{
      transform:scale(.7);
      margin-left: -2.5em;
    }
    textarea{
      border: 0 none;
    }
  }
  .title{
    display: block;
    position: relative;
    background-color: #eee;
    padding: .6em .6em .6em .5em;
    &:before{
      display: block;
      content: '';
      width: 2px;
      height: .8em;
      background-color: #da251d;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .pd{
    padding: .5em 1em;
  }
  .textarea-label{
    padding: .5em 1em;
    position: relative;
  }
  textarea{
    resize: none;
    width: 100%;
    height: 19em;
    box-sizing: border-box;
  }
  .words-count{
      position: absolute;
      right: 1em;
      bottom: 1em;
      z-index: 10;
      opacity: .5;
      transform: scale(.8);
    }
  body{
    background-color: #fff;
  }
  .submit-btn{
    display: block;
    margin: 2em auto;
    width: 60vw;
    line-height: 2;
    font-size: 1.1em;
    background-color: #da251d;
    color: #fff;
    border-radius: 2em;
    box-shadow: 0 0 1px 2px rgba(200, 0, 0, 0.2);
  }
</style>